import { useState } from "react";

export default function MobileEpisodeReview({reviewOverlayOpen, setReviewOverlayOpen}) {

    // get all the tags for a user
    const tags = ["yellow", "red", "blue", "purple"];

    const [query, setQuery] = useState("");
    const filteredTags = tags?.filter((tag) =>
         tag.toLowerCase().includes((query || "").toLowerCase())
    );
    
    const addTag = async (value) => {
        console.log("added tag: " + value);
    }

    const updateStatus = async (ep) => {
        // staStore.createEpisodeStatus(ep.seriesId, ep.seasonNumber, ep.episodeNumber, ep._id, "episode", "Watched");
        //staStore.createSeriesStatus(ep.seriesId, ep.seasonNumber, ep.episodeNumber, ep._id, "series", userStatus, rating, review, tags) ; // this is not done
    }

     const saveReview = async () => {
        //await staStore.createEpisodeStatus(???);
        
        setReviewOverlayOpen(false);
    };

    return (
        <div className="mobileOverlay mobileEpisodeReview">
            <button className="mobileOverlayCloseButton" onClick={() => setReviewOverlayOpen(false)}>button here</button>

            <h3>Status</h3>
            <button>Watched</button>

            <h3>Rate</h3>
            <div className="mobileEpRating">
                <img class="ratingStar" src="/assets/icons/star.png"></img>
                <img class="ratingStar" src="/assets/icons/star.png"></img>
                <img class="ratingStar" src="/assets/icons/star.png"></img>
                <img class="ratingStar" src="/assets/icons/star-border.png"></img>
                <img class="ratingStar" src="/assets/icons/star-border.png"></img>
            </div>

            <h3>Review</h3>
            <button>Add review</button>

            <h3>Tags</h3>
            <div class="dropdown">
                <input
                    autoFocus
                    type="text"
                    placeholder="add tag"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                         if (e.key === "Enter" && filteredTags?.length > 0) {
                            addTag(filteredTags[0]);
                            setQuery("");
                        }
                    }}
                />
                {query && (
                    <div className="mobileSearchResults">
                         {filteredTags?.length > 0 ? (
                            filteredTags?.map((tag) => (
                            <div
                                // key={tag._id}
                                className=""
                                onClick={() => {
                                    addTag(tag);
                                    setQuery("");
                                }}
                            >
                                {tag}
                            </div>
                        )) ) : (
                            <div></div>
                        )}
                        <p
                        onClick={() => {
                                    addTag(query);
                                    setQuery("");    
                                }}>Or add new tag: {query}</p>
                    </div>
                )}
            </div>
            <div>
                {tags?.map((tag) => (
                    <p>
                        {tag}
                    </p>
                ))}
            </div>

            <button onClick={() => {
                saveReview();
            }}>Save</button>
           
        </div>
    )
}